export const initialState = () => ({
  loading: {
    message: "",
    show: false
  },
  flow: {
    name: "",
    active: false,
    isDefault: false,
    useTermAcceptance: false,
    useDocumentAttachment: false,
    useSelfieCapture: false,
    validateBiometry: false,
    validateLiveness: false,
    useManualAnalysis: false,
    showCapturedDocumentPreview: false,
    showAttachedDocumentPreview: false,
    useBiometryRefusal: false,
    useDataCorrectionRequest: false,
    acceptedDocumentTypes: [],
    saleFlows: [],
    acceptPhysicalAsDigital: false,
    acceptedDigitalDocumentTypes: [],
    version: 'v2'
  },
  isCopying: false,
  isEditing: false,
  uuid: ""
})
